import React from 'react';
import PropTypes from 'prop-types';
import pushNotification from 'helpers/pushnotification/pushnotification';
import { gaWrapper } from 'helpers/analytics';
import throttle from 'lodash.throttle';
import _get from 'lodash.get';
import { isIOS } from 'utils/common';
import s from './NotificationHooks.scss';

const GAClickEvent = {
  action: 'click',
  label: 'pushSubscribe_Click',
};
const GAScrollEvent = {
  action: 'scroll',
  label: 'pushSubscribe_Seen',
};
class NotificationHooks extends React.Component {
  constructor() {
    super();
    this.state = {
      defaultText: undefined,
      showHooks: false,
    };
    this.ref = React.createRef();
  }
  componentDidMount() {
    const showHooks = pushNotification.checkBlockedStatus();
    const isSafari =
      typeof navigator !== 'undefined' &&
      navigator.vendor &&
      navigator.vendor.indexOf('Apple') > -1 &&
      navigator.userAgent &&
      navigator.userAgent.indexOf('CriOS') === -1 &&
      navigator.userAgent.indexOf('FxiOS') === -1;
    if (showHooks) {
      this.setState({
        showHooks,
        defaultText: _get(this.props.data, 'defaultText'),
      });
      this.throttledGAonScroll = throttle(this.handleGAOnScroll, 100);
      window.addEventListener('scroll', this.throttledGAonScroll);
    }
    window.addEventListener('Notification', this.triggerChangestextFn);
    if (isSafari) {
      this.setState({
        showHooks: false,
      });
    }
  }
  triggerChangestextFn = event => {
    this.changesText(event.detail);
  };
  removeScrollEvent = () => {
    window.removeEventListener('scroll', this.throttledGAonScroll);
  };

  componentWillUnmount() {
    window.removeEventListener('Notification', this.triggerChangestextFn);
  }

  isElementEdgesVisible = (el, skewFromTop) => {
    if (el) {
      const rect = el.getBoundingClientRect();
      const { top, bottom } = rect;
      const windowHeight =
        window.innerHeight || document.documentElement.clientHeight;

      if (skewFromTop) {
        return top <= windowHeight;
      }
      return bottom <= 0;
    }
    return false;
  };

  handleGAOnScroll = () => {
    // const data = this.state.articleshowData;
    const prevTop = 0;
    let currentTop = 0;
    const doc = document.documentElement;
    currentTop = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
    if (currentTop > prevTop) {
      if (
        this.ref &&
        this.ref.current &&
        this.isElementEdgesVisible(this.ref.current, true)
      ) {
        // GAs are made consitent, removed hard checks
        if (
          (this.props.gaCategory === 'liveblog_new_web' ||
            this.props.gaCategory === 'liveblog_new_mweb') &&
          GAScrollEvent.action === 'scroll'
        ) {
          this.removeScrollEvent();
          return;
        }
        if (this.props.gaCategory) {
          gaWrapper(
            'send',
            'event',
            this.props.gaCategory,
            GAScrollEvent.action,
            GAScrollEvent.label,
          );
        }
        this.removeScrollEvent();
      }
    }
  };

  getSubscribe = () => {
    // GAs are made consitent, removed hard checks
    if (this.props.gaCategory) {
      gaWrapper(
        'send',
        'event',
        this.props.gaCategory,
        GAClickEvent.action,
        GAClickEvent.label,
      );
    }
    pushNotification.subscribeUser(this.changesText);
  };
  changesText = info => {
    if (info === 'success' || info === 'Allow') {
      if (info === 'Allow' && this.props.gaCategory === 'SportsLiveblog_New') {
        gaWrapper(
          'send',
          'event',
          this.props.gaCategory,
          `Allow`,
          'liveUpdates_Subscribe',
        );
      } else {
        gaWrapper(
          'send',
          'event',
          this.props.gaCategory,
          `notification_subscribe_rhs_${this.props.isWapView ? 'mweb' : ''}`,
          'Success',
        );
      }
      if (typeof this.props.updatedText === 'function') {
        this.props.updatedText();
      } else {
        this.setState({ defaultText: _get(this.props.data, 'updatedText') });
      }
      //Hide after 5 sec
      setTimeout(() => {
        this.setState({ showHooks: false });
      }, 5000);
    } else if (
      info !== 'Closed' ||
      (info === 'Closed' &&
        typeof Notification !== 'undefined' &&
        Notification.permission === 'denied')
    ) {
      this.setState({ showHooks: false });
    }
  };
  render() {
    if (!this.state.showHooks || !this.state.defaultText || isIOS())
      return null;

    return this.props.children ? (
      <div ref={this.ref} onClick={this.getSubscribe}>
        {typeof this.props.children === 'function'
          ? this.props.children(this.state.defaultText)
          : this.props.children}
      </div>
    ) : (
      <div
        className={`${s.counterVisit} ${
          this.props.outlineDesign ? s.outlineBtn : ''
        }`}
        ref={this.ref}
      >
        <button
          onClick={() => {
            this.getSubscribe();
          }}
        >
          {this.state.defaultText}
        </button>
      </div>
    );
  }
}

NotificationHooks.propTypes = {
  data: PropTypes.shape({
    defaultText: PropTypes.string,
    updatedText: PropTypes.string,
  }).isRequired,
  children: PropTypes.any,
  updatedText: PropTypes.func,
  isWapView: PropTypes.bool,
  gaCategory: PropTypes.string,
};
NotificationHooks.defaultProps = {
  isWapView: false,
  children: null,
  updatedText: undefined,
  gaCategory: '',
};

export default NotificationHooks;
